export default {
  props: {
    theme: {
      type: String,
      default: '',
    },
  },
  computed: {
    classModifiers() {
      return {
        'no-data-dashed-box': true,
        [`no-data-dashed-box--${this.theme}`]: this.theme,
      };
    },
  },
};
